// management requests are sent to the management api

import { api } from 'api';
import axios, { type AxiosInstance } from 'axios';
import { type Role } from 'components/Permission/permission.types';
import { useAppSelector } from 'store/hook';
import { isInternalUserOrDirector } from 'utils/validators/role.validation';

const fallbackAccess =
  'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkE5eVRIWkN6YkxNaXRzWWtkX3FyQyJ9.eyJodHRwczovL3N5bWJvdGljd2FyZS5jb20vcm9sZSI6ImV4dGVybmFsLXVzZXIiLCJodHRwczovL3N5bWJvdGljd2FyZS5jb20vY3VzdG9tZXJfaWQiOiIwM2VlM2I3Ni0yYjUxLTQ4Y2UtYmZkMi0wNjc1YTE3YTdmM2QiLCJodHRwczovL3N5bWJvdGljd2FyZS5jb20vaW50ZXJuYWxfdXNlcl9pZCI6IjExMmZiZTRlLWNlNWEtNDZlNC05OTBkLWQyMjcwYjA3NTIyYSIsImlzcyI6Imh0dHBzOi8vZGV2LTBhN2o2ZW0zMTM0bTY1dGEudXMuYXV0aDAuY29tLyIsInN1YiI6ImF1dGgwfDY3MzM0MzQzNzJlNWNjZDRiZTc4NGQ3NyIsImF1ZCI6WyJodHRwczovL2Rldi0wYTdqNmVtMzEzNG02NXRhLnVzLmF1dGgwLmNvbS9hcGkvdjIvIiwiaHR0cHM6Ly9kZXYtMGE3ajZlbTMxMzRtNjV0YS51cy5hdXRoMC5jb20vdXNlcmluZm8iXSwiaWF0IjoxNzMxNDc2MTMxLCJleHAiOjE3MzE1NjI1MzEsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJhenAiOiIyRXJTZWhkcE5VTDhNbGJXbXN2MlcwdExHcWEzdXBSciJ9.g4c61jnjjjfrrUM3EOtKlOh6W72cqxtQ0Ug3wG1Se41tj33kN3X0VJdgnSvRMaalmUdHLoZkxLxPCYFzml-oGaQr3NM9h4VdJcXy-bLgs_8AumUXo3Eysq_mAxr_zwOeZgFzADtoLcmcsXSep_jwyUmvdnJrTK6G4xB-CZt4fFjZOBFK9uuDhSFBUY5UwwyxWHrdqR19w6OA6S-8cCZz3fwylcy0Q2pvX5bmKQQ_fQ3ovA12avfzsQIcIA5WsyvD1tuy1bJS_amQw1A8GtxgRP2BUrSq_SjIKRDN0Gj34W913heY6EWNV3SXWoliBj1gifU3iBp5_2A2Y5sjwBeX-Q';

export default abstract class BaseAPI {
  protected readonly axiosInstance: AxiosInstance;
  protected readonly API: any;
  protected readonly accessToken: string;
  protected readonly role: Role;
  protected readonly customerId: string;

  constructor() {
    this.accessToken =
      useAppSelector((state) => state.authReducer).accessToken ||
      fallbackAccess;
    this.role = useAppSelector((state) => state.authReducer).role as Role;
    this.customerId =
      useAppSelector((state) => state.persistedReducer).customer.id ||
      '8db60364-3afc-4a48-9f1e-d2afff948968';

    // configure axios instance
    this.axiosInstance = axios.create({
      baseURL: `${process.env.REACT_APP_MANAGEMENT_API_URL ?? ''}/api/`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.accessToken}`,
      },
      params: {
        // Add the selected customerId as query parameter if the user is an internal user
        ...(isInternalUserOrDirector(this.role) && {
          customerId: this.customerId,
        }),
      },
    });

    this.API = api(this.axiosInstance);
  }
}
